export const TRADE_OFFER_NOT_ACTUAL_OFFSET_BEFORE_EXPIRATION_MINUTES = 0;
export const TRADE_OFFER_PRE_EXPIRATION_MINUTES = 5;

export enum OFFER_ACTION_TYPE {
    OWN_WAREHOUSE = '1',
    RECEIVING_POINT = '0',
}